// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CGjS","tabsBox":"styles_tabsBox__3EwXw","createButton":"styles_createButton__2iFxY"};